// Prevent CSV formula injection by prefixing dangerous leading characters with an apostrophe
export function sanitizeCSVValue(value: string): string {
    if (typeof value !== 'string' || value.length === 0) return value;
    if ([ '=', '+', '-', '@', '\t', '\r' ].some(c => value.startsWith(c))) {
        return `'${value}`;
    }

    return value;
}

export function download(filename: string, text: string, cb?: () => void): void {
    const element = document.createElement('a');
    element.setAttribute('href', `data:text/plain;charset=utf-8,${encodeURIComponent(text)}`);
    element.setAttribute('download', filename);

    element.style.display = 'none';
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);

    if (typeof cb === 'function') {
        cb();
    }
}